<template>
  <detail-row-wrapper :save-function="submit" :cancel-function="cancel">
    <div class="contents-wrapper">
      <div class="main-contents">
        <detail-row-component title="이름">
          <layout-input
            v-model="editable.name"
            placeholder="이름을 입력해주세요."
            :regex="regex(1, 200).ko_en_num"
          />
        </detail-row-component>

        <detail-row-component title="주소" :inner-vertical="true">
          <layout-input
            v-model="editable.address"
            placeholder="주소를 입력해주세요."
            :regex="regex(1, 200).ko_en_num"
          />

          <layout-input v-model="editable.addressOvr" placeholder="덮어쓸 주소를 입력해주세요." />
        </detail-row-component>

        <detail-row-component title="창고">
          <layout-async-auto-complete
            v-model="editable.warehouseId"
            place-holder="창고를 검색하여 찾아주세요."
            :http-options="httpOptions"
            api-url="/api/warehouses"
            track-name="name"
            track-by="id"
            :regex="regex(1, 10000).ko_en_num"
          />
        </detail-row-component>

        <detail-row-component title="배송 지연 시간">
          <layout-input
            v-model="editable.deliveryDelayHours"
            type="number"
            placeholder="배송 지연시간을 입력해주세요. (단위: 시간)"
          />
        </detail-row-component>

        <detail-row-component title="국가">
          <layout-input v-model="editable.country" placeholder="국가를 입력해주세요." />
        </detail-row-component>

        <detail-row-component title="도 / 특별시">
          <layout-input v-model="editable.city" placeholder="도 혹은 특별시를 입력해주세요." />
        </detail-row-component>

        <detail-row-component title="시 / 구">
          <layout-input v-model="editable.administrative" placeholder="시 혹은 구를 입력해주세요." />
        </detail-row-component>

        <detail-row-component title="소재지" :inner-vertical="true">
          <layout-input v-model="editable.locality" placeholder="소재지를 입력해주세요." />

          <layout-input v-model="editable.localityDetail" placeholder="상세 소재지를 입력해주세요." />
        </detail-row-component>

        <detail-row-component title="도로명" :inner-vertical="true">
          <layout-input v-model="editable.street" placeholder="도로명을 입력해주세요." />

          <layout-input v-model="editable.streetDetail" placeholder="상세 도로명을 입력해주세요." />
        </detail-row-component>

        <detail-row-component title="위도 / 경도" :inner-vertical="true">
          <layout-input v-model="editable.latitude" placeholder="위도를 입력해주세요." />

          <layout-input v-model="editable.longitude" placeholder="경도를 입력해주세요." />
        </detail-row-component>

        <detail-row-component title="점포 타입">
          <layout-input v-model="editable.type" placeholder="점포 타입을 입력해주세요." />
        </detail-row-component>

        <detail-row-component title="cvs 점포 코드">
          <layout-input
            v-model="editable.bizlocCode"
            placeholder="cvs 점포 코드를 입력해주세요."
            :is-disabled="true"
          />
        </detail-row-component>

        <detail-row-component title="가는 길">
          <layout-textarea v-model="editable.howToGo" placeholder="가는길을 입력해주세요." />
        </detail-row-component>

        <detail-row-component title="점포 이미지">
          <layout-image-selector
            v-model="editable.imgPlace"
            :index="`image_address${rowData.id}`"
            :on-image-out-of-size="onImageOutOfSize"
          />
        </detail-row-component>

        <detail-row-component title="발행">
          <layout-switch-button v-model="editable.isEnabled" />
        </detail-row-component>
      </div>
    </div>
  </detail-row-wrapper>
</template>

<script>
import { validate, multipleValidate, regex } from "@/utils/utils";

import LayoutAsyncAutoComplete from "@/spa/components/LayoutAsyncAutoComplete";
import LayoutInput from "@/spa/components/LayoutInput";
import LayoutImageSelector from "@/spa/components/LayoutImageSelector";
import LayoutSwitchButton from "@/spa/components/LayoutSwitchButton";
import LayoutTextarea from "@/spa/components/LayoutTextarea";

import DetailRowWrapper from "@/spa/components/detail-row/DetailRowWrapper";
import DetailRowComponent from "@/spa/components/detail-row/DetailRowComponent";

export default {
  name: "OfflineStoreManageEditor",
  components: {
    DetailRowWrapper,
    DetailRowComponent,

    LayoutAsyncAutoComplete,
    LayoutInput,
    LayoutImageSelector,
    LayoutSwitchButton,
    LayoutTextarea
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  computed: {
    httpOptions() {
      return { headers: { Authorization: this.$store.getters.getToken } };
    }
  },
  methods: {
    onImageOutOfSize() {
      this.$toast("사이즈가 4메가가 넘습니다.");
    },

    regex(min, max) {
      return regex(min, max);
    },

    async uploadImage(image) {
      if (!image) return null;
      if (typeof image === "string") return image;

      const result = await this.$store.dispatch("imageUploadS3", {
        name: "address",
        image
      });

      if (!result.response) return image;
      this.$toast(result.message);
      this.$toast("데이터베이스 업로드 작업중 입니다. 조금만 기다려주세요.");

      return result.response.location;
    },

    async submit() {
      this.editable.id = this.rowData.id;
      this.editable.imgPlace = await this.uploadImage(this.editable.imgPlace);
      this.editable.deliveryDelayHours = parseInt(
        this.editable.deliveryDelayHours,
        10
      );

      const validateResult = multipleValidate([
        validate({
          message: "이름",
          target: this.editable.name,
          regex: this.regex(1, 200).ko_en_num
        }),
        validate({
          message: "주소",
          target: this.editable.address,
          regex: this.regex(1, 200).ko_en_num
        }),
        validate({
          message: "집화지",
          target: this.editable.warehouseId,
          regex: this.regex(1, 10000).ko_en_num,
          exception: !this.editable.warehouseId
        })
      ]);

      if (this.editable.isEnabled && validateResult.flag) {
        this.$toast(validateResult.message);
        return;
      }

      const result = await this.$store.dispatch("updateAddress", this.editable);

      if (result.response) {
        this.$table.updateField();
      }

      this.$toast(result.message);
    },

    cancel() {
      this.$table.updateField();
    }
  },
  data() {
    return {
      editable: {
        name: this.rowData.name,
        warehouseId: this.rowData.warehouse_id,
        deliveryDelayHours: this.rowData.delivery_delay_hours,
        address: this.rowData.address,
        country: this.rowData.country,
        city: this.rowData.city,
        administrative: this.rowData.administrative,
        locality: this.rowData.locality,
        street: this.rowData.street,
        localityDetail: this.rowData.locality_detail,
        streetDetail: this.rowData.street_detail,
        latitude: this.rowData.latitude,
        longitude: this.rowData.longitude,
        type: this.rowData.type || "wp_store",
        bizlocCode: this.rowData.bizloc_code,
        addressOvr: this.rowData.address_ovr,
        idDeleted: this.rowData.is_deleted,
        howToGo: this.rowData.how_to_go,
        imgPlace: this.rowData.img_place,
        isEnabled: this.rowData.is_enabled
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.contents-wrapper {
  position: relative;
  min-height: 600px;

  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;

  flex-direction: row;

  .main-contents {
    position: relative;
    width: 60%;

    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;

    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/address/detail-row/OfflineStoreManageEditor.vue